webpackJsonp([20],{

/***/ 1934:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  nome: 'resultado-importacao-csv-grvs',
  props: {
    relatorio: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      data: {
        quantidadeEnviada: 0,
        grvsInvalidas: [],
        grvsNaoEncontradas: []
      },
      isLoaded: false,
      semResultado: false
    };
  },

  computed: {
    total: function total() {
      return this.relatorio.quantidadeEnviada;
    },
    quantidadeGrvsInvalidas: function quantidadeGrvsInvalidas() {
      return this.relatorio.grvsInvalidas.length;
    },
    quantidadeGrvsNaoEncontradas: function quantidadeGrvsNaoEncontradas() {
      return this.relatorio.grvsNaoEncontradas.length;
    },
    quantidadeGrvsEncontradas: function quantidadeGrvsEncontradas() {
      return this.total - (this.quantidadeGrvsInvalidas + this.quantidadeGrvsNaoEncontradas);
    },
    porcentagemInvalidas: function porcentagemInvalidas() {
      return this.calculaPorcentagem(this.quantidadeGrvsInvalidas, this.total);
    },
    porcentagemNaoEncontradas: function porcentagemNaoEncontradas() {
      return this.calculaPorcentagem(this.quantidadeGrvsNaoEncontradas, this.total);
    },
    porcentagemEfetividade: function porcentagemEfetividade() {
      var valor = this.calculaPorcentagem(this.quantidadeGrvsEncontradas, this.total);
      return {
        valor: valor,
        class: parseInt(valor) === 100 ? 'text-success' : 'text-danger'
      };
    },
    grvsInvalidasFormatado: function grvsInvalidasFormatado() {
      return this.relatorio.grvsInvalidas.join('\n');
    },
    grvsNaoEncontradasFormatado: function grvsNaoEncontradasFormatado() {
      return this.relatorio.grvsNaoEncontradas.join('\n');
    }
  },
  mounted: function mounted() {
    this.isLoaded = true;
    console.log(this.relatorio);
  },

  filters: {
    formatarData: function formatarData(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD/MM/YYYY LTS');
    }
  },
  methods: {
    calculaPorcentagem: function calculaPorcentagem(valor, total) {
      if (total < 1) return 0;
      return (valor / total * 100).toFixed(2);
    }
  }
});

/***/ }),

/***/ 1950:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1903)(true);
// imports


// module
exports.push([module.i, ".resultado-estatísticas-importacao-csv[data-v-945a18ac]{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}.resultado-estatísticas-importacao-csv span[data-v-945a18ac]{font-weight:700}.resultado-success[data-v-945a18ac]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}textarea[data-v-945a18ac]{resize:none}", "", {"version":3,"sources":["/opt/buildhome/repo/src/app/website/leiloes/components/ResultadoImportacaoCsvGrv.vue"],"names":[],"mappings":"AACA,wDACE,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,mBAAoB,AACxB,sBAAuB,AACnB,mBAAoB,AACxB,yBAA0B,AACtB,4BAA8B,CACnC,AACD,6DACE,eAAkB,CACnB,AACD,oCACE,oBAAqB,AACrB,aAAc,AACd,0BAA2B,AACvB,sBAAuB,AAC3B,sBAAuB,AACnB,mBAAoB,AACxB,yBAA0B,AACtB,4BAA8B,CACnC,AACD,0BACE,WAAa,CACd","file":"ResultadoImportacaoCsvGrv.vue","sourcesContent":["\n.resultado-estatísticas-importacao-csv[data-v-945a18ac] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.resultado-estatísticas-importacao-csv span[data-v-945a18ac] {\n  font-weight: bold;\n}\n.resultado-success[data-v-945a18ac] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\ntextarea[data-v-945a18ac] {\n  resize: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1961:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1950);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1904)("317adc51", content, true, {});

/***/ }),

/***/ 1968:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1961)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1934),
  /* template */
  __webpack_require__(1988),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-945a18ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1988:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Resultado da importação")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(!_vm.semResultado) ? _c('div', {
    staticClass: "resultado-estatísticas-importacao-csv m-b-lg"
  }, [_c('div', [_vm._v("Total enviado: "), _c('span', [_vm._v(_vm._s(_vm.total))])]), _vm._v(" "), _c('div', [_vm._v("Grvs inválidas: "), _c('span', [_vm._v(_vm._s(_vm.quantidadeGrvsInvalidas) + " (" + _vm._s(_vm.porcentagemInvalidas) + "%)")])]), _vm._v(" "), _c('div', [_vm._v("Grvs não encontradas: "), _c('span', [_vm._v(_vm._s(_vm.quantidadeGrvsNaoEncontradas) + " (" + _vm._s(_vm.porcentagemNaoEncontradas) + "%)")])]), _vm._v(" "), _c('div', [_vm._v("Efetividade: "), _c('span', {
    class: _vm.porcentagemEfetividade.class
  }, [_vm._v(_vm._s(_vm.porcentagemEfetividade.valor) + "%")])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.semResultado) ? _c('div', {
    staticClass: "text-dark resultado-success m-t-xl"
  }, [_c('i', {
    staticClass: "fa fa-warning fa-5x"
  }), _vm._v(" "), _c('span', [_vm._v("Leilão não foi gerado via importação csv de Grvs!")])]) : (parseInt(_vm.porcentagemEfetividade.valor) === 100) ? _c('div', {
    staticClass: "text-success resultado-success m-t-xl"
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-5x"
  }), _vm._v(" "), _c('span', [_vm._v("Todos as Grvs foram encontradas!")])]) : _c('div', {
    staticClass: "resultado-estatísticas-importacao-csv"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "txt-placas-invalidas"
    }
  }, [_vm._v("Grvs inválidas:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grvsInvalidasFormatado),
      expression: "grvsInvalidasFormatado"
    }],
    staticClass: "form-control",
    staticStyle: {
      "white-space": "pre-wrap"
    },
    attrs: {
      "id": "txt-placas-invalidas",
      "cols": "30",
      "rows": "10",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.grvsInvalidasFormatado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grvsInvalidasFormatado = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "txt-placas-nao-encontradas"
    }
  }, [_vm._v("Grvs não encontradas: "), _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "A placa não foi encontrada no sistema, ou não está com status 'no pátio'"
    }
  })]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grvsNaoEncontradasFormatado),
      expression: "grvsNaoEncontradasFormatado"
    }],
    staticClass: "form-control",
    staticStyle: {
      "white-space": "pre-wrap"
    },
    attrs: {
      "id": "txt-placas-nao-encontradas",
      "cols": "30",
      "rows": "10",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.grvsNaoEncontradasFormatado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grvsNaoEncontradasFormatado = $event.target.value
      }
    }
  })])])])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/20.acb9f8a21c01d1ae8f52.js